// extracted by mini-css-extract-plugin
export default {"scroll-top":"ScrollTop_scroll-top__Rj3F-"};